export const API_URL = "https://posted-9ped.onrender.com";

//export const API_URL = "http://localhost:4000"
export const BD_URL = "https://api.cloudinary.com/v1_1/drgnllwbv/image/upload"